import { Controller, useFormContext } from 'react-hook-form'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { CostCenterAllocations } from 'modules/cost_centers/components/CostCenterAllocations'
import { LINKABLE_RESOURCES } from 'modules/cost_centers/lib/types'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'cost_centers'

const RESOURCE_TYPE = 'Expenses::Expensable'

interface Props extends WithFieldPermissionsProps, WithCustomizationFieldsProps {
  resourceId?: string
  employeeId: string
}

const CostCenterField = ({ resourceId, employeeId, expensable, isFieldReadOnly }: Props) => {
  const { control, watch, getValues } = useFormContext()
  const { start_date: startDate, effectiveOn } = getValues()

  const options = [
    {
      label: i18n.t('cost_centers.select_options.employee'),
      resourceType: LINKABLE_RESOURCES.Employee,
      resourceId: employeeId,
    },
  ]

  const resourceDate = useUnsafeMemo(() => {
    if (startDate) {
      return startDate
    }
    return effectiveOn || new Date().toISOString()
  }, [startDate, effectiveOn])

  watch(FIELD_NAME)

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <CostCenterAllocations
          resourceType={RESOURCE_TYPE}
          resourceId={resourceId}
          referenceResourceId={employeeId}
          options={options}
          resourceDate={resourceDate}
          onChange={field.onChange}
          distribution={expensable?.costCenterDistribution}
          defaultSelectOption={LINKABLE_RESOURCES.Employee}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(CostCenterField, FIELD_NAME))
